module.exports = __webpack_public_path__ + "img/charging-station-infographic-desktop-fr.8b354fb0.webp";